import { getPermissions } from '../../config/Auth';
import { ACTIONS } from '../enums/PermissionEnums';
import menu from '../../config/Menu';
import { Left } from '../utils/Global';

export function hasPermissionByKeys(keys, permissions = getPermissions()) {
    var retorno = true;

    if (
        process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_IGNORE_PERMISSIONS === 'true'
    ) {
        return retorno;
    }

    if (keys !== null) {
        for (let i = 0; i < keys.length; i++) {
            if (Array.isArray(permissions) && !permissions.includes(keys[i])) {
                retorno = false;
                break;
            }
        }
    }

    return retorno;
}

export function getAllRoutesByPage(path) {
    const listMenu = menu();

    function getRouteByPath(path) {
        var routes = [];

        for (let i = 0; i < listMenu.length; i++) {
            if (!listMenu[i]?.items) {
                if (listMenu[i]?.to.includes(path)) routes.push(listMenu[i]);
            } else {
                const retorno = listMenu[i].items.filter((el) => `${el?.to ?? ''}`.includes(path));
                if (retorno.length >= 0) routes = [...routes, ...retorno];
            }
        }
        return routes.length > 0 ? routes : null;
    }
    var usePath = path;
    if (path.includes('/edit/:id/view')) {
        usePath = path.split('/edit/:id/view')[0];
    } else if (path.includes('/new')) {
        usePath = path.split('/new')[0];
    } else if (path.includes('/edit/:id')) {
        usePath = path.split('/edit/:id')[0];
    }

    let res = getRouteByPath(usePath);

    if (res) {
        res = res.reduce((acumulador, el) => {
            if (el.to === usePath) acumulador[ACTIONS.VISUALIZAR] = el;
            else if (el.to.includes(`${usePath}/edit/:id/view`)) acumulador[ACTIONS.CONSULTAR] = el;
            else if (el.to.includes(`${usePath}/edit/:id`)) acumulador[ACTIONS.EDITAR] = el;
            else if (el.to.includes(`${usePath}/new`)) acumulador[ACTIONS.INCLUIR] = el;

            return acumulador;
        }, {});

        if (res?.[ACTIONS.VISUALIZAR]?.permissionKeys) {
            let firstKey = res[ACTIONS.VISUALIZAR].permissionKeys.filter((el) =>
                el.includes(`.${ACTIONS.VISUALIZAR}`)
            )[0];

            if (!firstKey) {
                firstKey = res[ACTIONS.VISUALIZAR].permissionKeys.filter((el) =>
                    el.includes(`_${ACTIONS.VISUALIZAR}`)
                )[0];
            }
            let temChave = false;
            let chaveDeletar = `${firstKey}`.replace(
                `.${ACTIONS.VISUALIZAR}`,
                `.${ACTIONS.DELETAR}`
            );
            if (!`${firstKey}`.includes(`.${ACTIONS.VISUALIZAR}`)) {
                let ultimaOcorrencia = `${firstKey}`.lastIndexOf(`_${ACTIONS.VISUALIZAR}`);
                if (ultimaOcorrencia > 0) {
                    let novaChave = Left(
                        `${firstKey}`,
                        `${firstKey}`.length - `_${ACTIONS.VISUALIZAR}`.length
                    ).trim();
                    chaveDeletar = `${novaChave}_${ACTIONS.DELETAR}`;
                    temChave = true;
                }
            } else {
                temChave = true;
            }

            res[ACTIONS.DELETAR] = {
                permissionKeys: temChave ? [chaveDeletar] : null,
            };
        } else {
            res[ACTIONS.DELETAR] = {
                permissionKeys: null,
            };
        }
    }

    return res;
}

export const hasPermissionByRouteList = (menu) => {
    const permissions = getPermissions();

    const check = (item) => {
        if (item?.permissionKeys) {
            const has = hasPermissionByKeys(item?.permissionKeys, permissions);
            item.visibleOnRouter = has;
            item.visibleOnMenu = has;
        } else {
            item.visibleOnRouter = true;
            item.visibleOnMenu = true;
        }
        return item;
    };

    const setVisibleRouter = (lista) => {
        for (let i = 0; i < lista.length; i++) {
            if (!lista[i]?.items) {
                lista[i] = check(lista[i]);
            } else {
                lista[i].items = setVisibleRouter(lista[i]?.items);
            }
        }
        return lista;
    };

    menu = setVisibleRouter(menu);

    return menu;
};
